import React from 'react';
import { useLanguage } from '../LanguageContext'; // ✅ import

const Contact = () => {
  const { language } = useLanguage(); // ✅ use it

  return (
    <section className="bg-custom-hero text-black text-center py-20 px-4">
      <div className="max-w-2xl mx-auto text-center">
        <h2 className="text-3xl font-bold mb-6">
          {language === 'id' ? 'Hubungi kami' : 'Contact us'}
        </h2>
        <p className="mb-4">
          {language === 'id'
            ? 'Tertarik membuat website? Yuk diskusi!'
            : 'Interested in a website? Let’s chat!'}
        </p>
        <a href="mailto:info@dinikdelavega.com" className="text-blue-600 underline">
          info@dinikdelavega.com
        </a>
      </div>
    </section>
  );
};

export default Contact;
